import { useEffect, useRef, useState } from 'react';

/**
 * An action carried out only after a countdown the user can undo: the second confirmation of a
 * step that cannot be changed afterwards. `remaining` is null when nothing is counting.
 */
export function useUndoCountdown(seconds: number, action: () => void) {
  const [remaining, setRemaining] = useState<number | null>(null);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);
  const actionRef = useRef(action);
  actionRef.current = action;

  const stop = () => {
    if (timer.current != null) clearInterval(timer.current);
    timer.current = null;
    setRemaining(null);
  };

  const start = () => {
    stop();
    let left = seconds;
    setRemaining(left);
    timer.current = setInterval(() => {
      left -= 1;
      if (left > 0) {
        setRemaining(left);
        return;
      }
      stop();
      actionRef.current();
    }, 1000);
  };

  useEffect(
    () => () => {
      if (timer.current != null) clearInterval(timer.current);
    },
    [],
  );

  return { remaining, counting: remaining != null, start, stop };
}
